<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card >
      <v-card-text>
        <v-row justify="center">
          <v-col sm="3">
            <h3>Notice & HW</h3>
          </v-col>
        </v-row>
        <v-row justify="center" dense>
          <v-col sm="2">
            <v-icon color="error">*</v-icon>
            <v-combobox
              dense
              required
              v-model="academicyear"
              :items="ay_list"
              item-text="ay"
              item-value="id"
              label="Academic Year"
              outlined
            />
          </v-col>
          <v-col sm="2">
            <v-icon color="error">*</v-icon>
            <v-combobox
              dense
              required
              v-model="stream"
              :items="stream_list"
              item-text="name"
              label="Stream"
              @change="get_divisions_stream(stream)"
              outlined
            />
          </v-col>
          <!-- <v-col sm="2" v-if="standard_list.length > 0">
            <v-icon color="error">*</v-icon>
            <v-combobox
              dense
              required
              v-model="standard"
              :items="standard_list"
              item-text="name"
              item-value="id"
              label="Standard"
              outlined
            />
          </v-col> -->
          <v-col sm="2" v-if="division_list.length > 0">
            <v-icon color="error">*</v-icon>
            <v-combobox
              dense
              required
              v-model="division"
              :items="division_list"
              item-text="divname"
              label="Division"
              outlined
            />
          </v-col>
        </v-row>
        <v-row>
        </v-row>
        <v-col cols="12">
          <v-text-field label="Title" v-model="title" placeholder="Colleges reopens"></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-textarea
            label="Description"
            v-model="description"
            value
            placeholder="Colleges reopens on...."
            hint="Enter description of notice or home work"
          ></v-textarea>
        </v-col>
        <v-col cols="12">
          <v-file-input
            v-model="attachments"
            placeholder="Upload attachment if any"
            label="Attachment"
            multiple
            prepend-icon="mdi-paperclip"
          >
            <template v-slot:selection="{ text }">
              <v-chip small label color="primary">{{ text }}</v-chip>
            </template>
          </v-file-input>
        </v-col>

        <v-btn @click="putCalendar" :loading="send_btn_load">Send</v-btn>
      </v-card-text>
    </v-card>
    <br />
    <div>
      <div>
        <v-data-table
          :items="communication_list"
          :headers="headers"
          class="elevation-1"
          :search="search"
        >
          <template v-slot:top>
            <v-toolbar flat color="white" align="center" justify="center">
              <v-toolbar-title>List of Notices</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-toolbar>
          </template>
          <template v-slot:[`item.edit`]="{item}">
            <div>
              <v-btn
                color="secondary"
                icon
                dark
                v-on="on"
                @click="editDialog(item)"
                title="Edit Calendar Event"
              >
                <!-- <v-icon left>mdi-email-send-outline</v-icon> -->
                <v-icon>mdi-file-document-edit</v-icon>
              </v-btn>
            </div>
          </template>
          <template v-slot:[`item.delete`]="{item}">
            <div>
              <v-btn
                color="warning"
                icon
                dark
                v-on="on"
                @click="deleteCalendarEvent(item)"
                title="Delete Calendar Event"
                :loading="delete_attach_load"
              >
                <!-- <v-icon left>mdi-email-send-outline</v-icon> -->
                <v-icon>mdi-delete-empty</v-icon>
              </v-btn>
            </div>
          </template>
        </v-data-table>
      </div>
    </div>
    
  </div>
</template>
<script>
import axios from "axios";
export default {
  data: () => ({
     file_upload_config: { allowed_type: "", max_size: 1000 },
    rules: [
      value =>
        !value || value.size < 2000000 || "Logo size should be less than 2 MB!"
    ],
    attachments: [],
    ay_list:[],
    academicyear:"",
    stream:"",
    stream_list:[],
    event_type_list: [],
    division_list:[],
    standard_list:[],
    division:"",
    standard:"",
    event_type:"",
    datetime: null,
    search: "",
    snackbar_msg: "",
    snackbar: false,
    color: "",
    communication_list: "",
    awspath: null,
    send_btn_load:false,
    headers: [
      { text: "Sent Date", value: "date", sortable: true },
      { text: "From", value: "from", sortable: true },
      { text: "To", value: "to", sortable: true },
      { text: "Title", value: "title", sortable: true },
      { text: "Description", value: "description", sortable: true },
      { text: "Edit", value: "edit", sortable: false },
      { text: "Delete", value: "delete", sortable: false },
    ],
  }),
  watch: {
  },
  methods: {
    get_divisions_stream(stream){
       const formData = {
        ay: this.academicyear.id,
        stream:stream.id
      };
      axios
        .post("/Communication/get_stream_divisions", formData)
        .then(res => {
          if (res.data.flag == "Yes") {
                this.division_list = res.data.division_list;
                // this.standard_list=res.data.standard_list;
          }
        })
        .catch(error => {
          window.console.log(error);
        })
        .finally(() => {
        });
    },
    putCalendar() {
        this.send_btn_load = true;
        let formData = new FormData();
         for (var i = 0; i < this.attachments.length; i++) {
        let file = this.attachments[i];
        formData.append("files", file);
        }
        formData.append("ay", this.academicyear.id);
        formData.append("stream", this.stream.id);
        formData.append("div", this.division.id);
        formData.append("title", this.title);
        formData.append("description", this.description);
        formData.append("type", "Notice");
        formData.append("to", "Parent");
        axios
          .post("/Communication/putNoticeHWAlbum", formData, {})
          .then(res => {
            if (res.data.msg == "200") {
              if (res.data.status == "SUCCESS") {
                // alert("Success");
                this.showSnackbar("#4caf50","Notice/Hw added successfully..."); // show snackbar on success
              } else {
                this.showSnackbar("#b71c1c", res.data.status_reason); // show snackbar
                //alert(res.data.status_reason);
              }
              //this.get_calendar();
            }
          })
          .catch(error => {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
            window.console.log(error);
          })
          .finally(() => {
            //close loader
            this.send_btn_load = false;
            this.get_ay_std();
          });
    },
    get_ay_std() {
       const formData = {
        comm_type: "Notice"
      };
      axios
        .post("/Communication/gerInitialData",formData)
        .then(res => {
          if (res.data.flag == "YES") {
           this.communication_list=res.data.communication_list
           this.ay_list=res.data.ay_list,
           this.academicyear=res.data.current_ay
           this.stream_list=res.data.stream_list_all
          } else {
            //error
          }
        })
        .catch(error => {
          window.console.log(error);
        })
        .finally(() => {
          //close loader
          this.first_load = true;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    deleteCalendarEvent(item) {
      this.delete_attach_load = true;
      //alert(item.id)
      if (!confirm("Are you sure you want to delete this calendar event?"))
        return;
      const formData = {
        comm_id: item.id
      };
      axios
        .post("/communicationType/deleteCommunication", formData)
        .then(res => {
          if (res.data.status == "YES") {
            this.showSnackbar("#4caf50", res.data.status_reason); // show snackbar on success
            //alert(res.data.status_reason)
            const index = this.event_type.indexOf(item);
            this.get_ay_std();
            //this.event_type.splice(index, 1);
          } else {
            this.showSnackbar("#b71c1c", res.data.status_reason); // show snackbar
            //alert(res.data.status_reason)
          }
        })
        .catch(error => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          //close loader
          this.delete_attach_load = false;
        });
    },
  },
  mounted() {
    this.get_ay_std();
  }
};
</script>
<style scoped>
.allot-btn,
.allot-icon,
.info-icon {
  transition: 0.3s;
}
.allot-btn:hover .allot-icon {
  color: white;
}
.allot-btn:hover {
  background-color: #193a9a !important;
  border-color: #193a9a !important;
  color: white;
}

.info-icon:hover {
  background-color: #193a9a !important;
  border-color: #193a9a !important;
  color: white;
  border-radius: 100%;
}
.table-sub-title {
  margin-left: 1%;
  font-weight: 500;
  color: #999;
}
@media print {
  body {
    height: 100%;
    width: 100%;
  }
  .no-display {
    display: none !important;
  }
  .v-data-footer,
  .v-data-footer__select,
  .v-data-footer__pagination {
    display: none !important;
    visibility: hidden !important;
  }
  .v-data-table table,
  .v-data-table__wrapper {
    width: 100% !important;
    display: block !important;
  }

  table,
  th,
  td {
    border-collapse: collapse !important;
    border: 1px solid black !important;
    width: 100%;
    text-align: right !important;
  }
}
</style>
